module.exports = __webpack_public_path__ + "img/人行配置.a47d3141.svg";